import {
  paymentMonthlyOptions, paymentWeeklyOptions, getWeekRanges,
  getBiWeekRanges, getMonthRanges,
} from '@utils';

const DATE_OPTIONS = { day: '2-digit', month: '2-digit', year: 'numeric' };

export default {
  frequencyOptions: [
    {
      label: 'Monthly',
      value: 'monthly',
    },
    {
      label: 'Weekly',
      value: 'weekly',
    },
    {
      label: 'Every two weeks',
      value: 'biweekly',
    },
    {
      label: 'Annually',
      value: 'annually',
    },
  ],
  data() {
    return {
      frequency: undefined,
      paymentDay: undefined,
    };
  },
  computed: {
    paymentDayOptions() {
      return (this.frequency === 'monthly' || this.frequency === 'annually') ? paymentMonthlyOptions() : paymentWeeklyOptions();
    },
    enableDay() {
      if (this.frequency === 'annually') {
        return null;
      }
      return { frequency: this.frequency, day: this.paymentDay };
    },
    minAutoPayDate() {
      const today = new Date();
      const day = today.getDate();

      if (this.frequency === 'annually') {
        return today;
      }

      if (this.frequency === 'monthly') {
        if (day <= this.paymentDay) return today;

        // Get the first day of the next month
        return new Date(today.getFullYear(), today.getMonth() + 1, 1);
      }

      const interval = this.frequency === 'weekly' ? 7 : 14;
      const daysUntilNextPayment = (Math.abs(this.paymentDay - today.getDay()) + interval)
        % interval;
      return new Date(
        today.getFullYear(),
        today.getMonth(),
        today.getDate() + daysUntilNextPayment,
      );
    },
    billingDateRangeOptions() {
      const options = [];
      if (!this.scheduledAt) {
        return [];
      }
      if (this.frequency === 'annually') {
        options.push(...this.billingDateAnnualOptions());
      } else if (this.frequency === 'monthly') {
        options.push(...this.billingDateMonthlyOptions());
      } else if (this.frequency === 'weekly') {
        options.push(...this.billingDateWeeklyOptions());
      } else {
        options.push(...this.billingDateBiWeeklyOptions());
      }
      return options;
    },
  },
  methods: {
    updateData() {},

    handleInputChange(field) {
      if (['frequency', 'paymentDay'].includes(field)) {
        this.scheduledAt = null;
      }
      if (field === 'scheduledAt') {
        this.careFrom = null;
        if (this.frequency === 'annually') {
          this.careFrom = this.billingDateAnnualOptions()[0].value;
        }
      }

      const valid = this.tuitionAmount && this.tuitionAmount > 0 && this.frequency && this.paymentDay && this.careFrom && this.scheduledAt;
      this.disable = !valid;

      this.updateData();
    },
    billingDateWeeklyOptions() {
      const weekRange = getWeekRanges(this.scheduledAt);
      const previousWeek = `${weekRange.previousWeek.start.toLocaleDateString()} - ${weekRange.previousWeek.end.toLocaleDateString()}`;
      const currentWeek = `${weekRange.currentWeek.start.toLocaleDateString()} - ${weekRange.currentWeek.end.toLocaleDateString()}`;
      const nextWeek = `${weekRange.nextWeek.start.toLocaleDateString()} - ${weekRange.nextWeek.end.toLocaleDateString()}`;
      return [
        {
          label: `Previous period (${previousWeek})`,
          value: weekRange.previousWeek.start.toLocaleDateString(undefined, DATE_OPTIONS),
        },
        {
          label: `Current period (${currentWeek})`,
          value: weekRange.currentWeek.start.toLocaleDateString(undefined, DATE_OPTIONS),
        },
        {
          label: `Next period (${nextWeek})`,
          value: weekRange.nextWeek.start.toLocaleDateString(undefined, DATE_OPTIONS),
        },
      ];
    },
    billingDateBiWeeklyOptions() {
      const weekRange = getBiWeekRanges(this.scheduledAt);
      const previousWeek = `${weekRange.previousBiweek.start.toLocaleDateString()} - ${weekRange.previousBiweek.end.toLocaleDateString()}`;
      const currentWeek = `${weekRange.currentBiweek.start.toLocaleDateString()} - ${weekRange.currentBiweek.end.toLocaleDateString()}`;
      const nextWeek = `${weekRange.nextBiweek.start.toLocaleDateString()} - ${weekRange.nextBiweek.end.toLocaleDateString()}`;
      return [
        {
          label: `Previous period (${previousWeek})`,
          value: weekRange.previousBiweek.start.toLocaleDateString(undefined, DATE_OPTIONS),
        },
        {
          label: `Current period (${currentWeek})`,
          value: weekRange.currentBiweek.start.toLocaleDateString(undefined, DATE_OPTIONS),
        },
        {
          label: `Next period (${nextWeek})`,
          value: weekRange.nextBiweek.start.toLocaleDateString(undefined, DATE_OPTIONS),
        },
      ];
    },
    billingDateMonthlyOptions() {
      const monthRange = getMonthRanges(this.scheduledAt);
      return [
        {
          label: `Previous period (${monthRange.prevMonth.from.toLocaleDateString()} - ${monthRange.prevMonth.to.toLocaleDateString()})`,
          value: monthRange.prevMonth.from.toLocaleDateString(undefined, DATE_OPTIONS),
        },
        {
          label: `Current period (${monthRange.currentMonth.from.toLocaleDateString()} - ${monthRange.currentMonth.to.toLocaleDateString()})`,
          value: monthRange.currentMonth.from.toLocaleDateString(undefined, DATE_OPTIONS),
        },
        {
          label: `Next period (${monthRange.nextMonth.from.toLocaleDateString()} - ${monthRange.nextMonth.to.toLocaleDateString()})`,
          value: monthRange.nextMonth.from.toLocaleDateString(undefined, DATE_OPTIONS),
        },
      ];
    },
    billingDateAnnualOptions() {
      const monthRange = getMonthRanges(this.scheduledAt);
      return [
        {
          label: `Current period (${monthRange.currentMonth.from.toLocaleDateString()} - ${new Date(monthRange.currentMonth.from.getFullYear() + 1, monthRange.currentMonth.from.getMonth(), monthRange.currentMonth.from.getDate() - 1).toLocaleDateString()})`,
          value: monthRange.currentMonth.from.toLocaleDateString(undefined, DATE_OPTIONS),
        },
      ];
    },
    validRecurringItems() {
      return this.recurringLineItems
        && this.recurringLineItems.length > 0
        && this.recurringLineItems.every((item) => item.amount && item.text)
        && this.recurringLineItems.reduce((sum, item) => sum + item.amount, 0) > 0;
    },
  },
};
